import type { GameState } from '../../types/simulation.js';
import { deserializeGameState, serializeGameState } from './serialization.js';

const MAIN_KEY = 'potus:save:main';
const RECOVERY_KEY = 'potus:save:recovery';
const SNAPSHOT_KEY = 'potus:save:snapshots';

export class SaveService {
  save(state: GameState, kind: 'manual' | 'autosave' | 'recovery' = 'manual'): void {
    const next = structuredClone(state);
    const at = new Date().toISOString();
    next.save.lastSavedAt = at;
    if (kind === 'autosave') next.save.lastAutosaveAt = at;
    const raw = serializeGameState(next);
    localStorage.setItem(kind === 'recovery' ? RECOVERY_KEY : MAIN_KEY, raw);
    if (kind === 'manual') this.snapshot(next);
  }

  load(): GameState | null {
    const raw = localStorage.getItem(MAIN_KEY);
    return raw ? deserializeGameState(raw) : null;
  }

  loadRecovery(): GameState | null {
    const raw = localStorage.getItem(RECOVERY_KEY);
    return raw ? deserializeGameState(raw) : null;
  }

  export(state: GameState): Blob {
    return new Blob([serializeGameState(state)], { type: 'application/json' });
  }

  import(raw: string): GameState {
    return deserializeGameState(raw);
  }

  private snapshot(state: GameState): void {
    const current = JSON.parse(localStorage.getItem(SNAPSHOT_KEY) ?? '[]') as string[];
    current.unshift(serializeGameState(state));
    localStorage.setItem(SNAPSHOT_KEY, JSON.stringify(current.slice(0, 5)));
  }
}
